// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const avatarClasses = {
  content: "qui-avatar__content",
  image: "qui-avatar__image",
  root: "qui-avatar__root",
  status: "qui-avatar__status",
} as const
